import { StateCreator } from 'zustand';
import {
  ToolsResourcesData,
  Tab,
  ToolsResourcesStore
} from '@interfaces/tools-resources-store';

const initialState = {
  toolsResourcesData: {} as ToolsResourcesData,
  tabs: [] as Tab[]
};

export const ToolsResourcesSlice: StateCreator<ToolsResourcesStore> = (
  set
) => ({
  ...initialState,
  updateTabs: (tabs: Tab[]) => set({ tabs: tabs }),
  updateToolsResource: (toolsResourcesData: ToolsResourcesData) =>
    set({ toolsResourcesData: toolsResourcesData }),
  resetResourceStore: () => set(initialState)
});
